import { useCallback } from 'react'
import Map from '../map'

export default function Location({ lat, lng, title, zoom = 14.6, allLocations }) {
  const handleMapLoad = useCallback(
    (map) => {
      let markerColour = '#0E77EF'
      new window.google.maps.Circle({
        map,
        fillColor: markerColour,
        fillOpacity: 0.2,
        strokeColor: markerColour,
        strokeOpacity: 0.4,
        strokeWeight: 2,
        center: { lat, lng },
        radius: 1000,
      })

      const markerIcon = {
        path:
          'M14.5,0A14.368,14.368,0,0,0,8.836,1.133a14.559,14.559,0,0,0-7.7,7.7A14.368,14.368,0,0,0,0,14.5a20.065,20.065,0,0,0,1.223,6.525A65.886,65.886,0,0,0,4.531,28.57Q6.57,32.58,9.153,37.02q2.628,4.486,5.347,9.38,2.719-4.894,5.3-9.38,2.628-4.441,4.667-8.451a60.289,60.289,0,0,0,3.262-7.545A19.429,19.429,0,0,0,29,14.5a14.368,14.368,0,0,0-1.133-5.664,14.559,14.559,0,0,0-7.7-7.7A14.368,14.368,0,0,0,14.5,0Zm0,20.3a5.8,5.8,0,0,1-5.8-5.8,5.8,5.8,0,0,1,5.8-5.8,5.8,5.8,0,0,1,5.8,5.8,5.8,5.8,0,0,1-5.8,5.8Z',
        fillColor: markerColour,
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 1,
        anchor: new window.google.maps.Point(15, 30),
      }

      new window.google.maps.Marker({
        position: { lat, lng },
        map,
        icon: markerIcon,
        title,
      })

      let allLocationsOtherThanThisLocation =
        !allLocations || allLocations.length == 0
          ? []
          : allLocations.filter((loc) => loc.lat !== lat || loc.lng !== lng)

      if (allLocationsOtherThanThisLocation.length > 0) {
        allLocationsOtherThanThisLocation.forEach((loc) => {
          new window.google.maps.Marker({
            position: { lat: loc.lat, lng: loc.lng },
            map,
            icon: markerIcon,
            title: loc.title,
          })
        })
      }
    },
    [lat, lng],
  )

  return (
    <>
      <Map
        style={{ width: '100%', height: '64.5rem' }}
        options={{ zoom, center: { lat, lng } }}
        onMapLoad={handleMapLoad}
        className='mapWrapper'
      />

      <style jsx>{`
        @media (min-width: 1025px) and (max-width: 1364px) {
          :global(.mapWrapper) {
            height: 38.8rem !important;
          }
        }
      `}</style>
    </>
  )
}
